import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: calc(100vh - 440px);\n  padding: 36px 0;\n\n  .inner {\n    text-align: center;\n    padding: 0 16px;\n\n    img {\n      max-width: 90%;\n    }\n\n    .text {\n      font-size: 14px;\n      color: ",
        ";\n      line-height: 1.5;\n      margin: 0;\n    }\n\n    .ant-btn {\n      width: 100%;\n      max-width: 384px;\n      height: 48px;\n      margin-top: 24px;\n\n      span {\n        font-size: 16px;\n        font-weight: bold;\n        color: #fff;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import Image from "next/image";
import { themeGet } from "@styled-system/theme-get";
import { Button } from "antd";
import React from "react";
import { HOME_PAGE } from "@/settings/constant";
import Link from "next/link";
export default function Custom404() {
    return /*#__PURE__*/ _jsx(CustomErrorWrapper, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "inner",
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    src: "/static/assets/error_404.png",
                    alt: "에러",
                    width: 792,
                    height: 564
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: "text",
                    children: [
                        "안타깝게도, 페이지를 잃어버렸어요. ",
                        /*#__PURE__*/ _jsx("br", {}),
                        "페이지가 없거나 오류가 발생한 것 같아요."
                    ]
                }),
                /*#__PURE__*/ _jsx(Link, {
                    href: "".concat(HOME_PAGE),
                    passHref: true,
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "primary",
                        children: "일단 홈으로 모실게요."
                    })
                })
            ]
        })
    });
}
export const CustomErrorWrapper = styled.div.withConfig({
    componentId: "sc-899ec656-0"
})(_templateObject(), themeGet("text.0", "#1B1B29"));
